import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-catalog-page-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './catalog-page-header.component.html',
  styleUrl: './catalog-page-header.component.scss',
})
export class CatalogPageHeaderComponent {
  @Input() title = '';
  @Input() uiConfig: any = null;
  @Output() toggleSidebar = new EventEmitter<void>();
  @Output() refresh = new EventEmitter<void>();
}
